export default "__VITE_ASSET__CNtmuc8F__"